import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["firstDegreeField", "secondDegreeField", "radio"]

  connect() {
    this.refresh()
  }

  refresh() {
    const selected = this.radioTargets.find((r) => r.checked)
    const level = selected ? selected.value : null
    this.firstDegreeFieldTargets.forEach((el) => el.hidden = level !== "first_degree")
    this.secondDegreeFieldTargets.forEach((el) => el.hidden = level !== "second_degree")
    this.radioTargets.forEach((r) => {
      r.closest(".option-card").classList.toggle("is-selected", r.checked)
    })
  }
}
